import { styled } from '@mui/material/styles';
import { Box, Avatar, Chip, Badge, Typography } from '@mui/material';

export const ProfileContainer = styled(Box)(({ theme }) => ({
  display: 'flex', 
  alignItems: 'center', 
  gap: 0.5
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 36,
  height: 36,
  backgroundColor: 'primary.main',
  fontSize: '0.875rem',
  fontWeight: 600,
}));

interface StyledMenuOpenerProps {
  hideHoverBg?: boolean
}

export const StyledMenuOpener = styled(Box)<StyledMenuOpenerProps>(({ theme, hideHoverBg }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  flex: 1,
  minWidth: 0,
  cursor: 'pointer',
  borderRadius: 2,
  padding: 5,
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: hideHoverBg ? "transparent" : theme.palette.action.hover ,
  },
}));

export const StyledBadge = styled(Badge)({
  '& .MuiBadge-badge': {
    fontSize: 15,
    minWidth: 20,
    height: 20,
    padding: 0,
    right: 5,
    bottom: 5,
    backgroundColor: 'transparent',
  },
  marginRight: 10
});

export const StyledTypographyName = styled(Typography)({
  fontWeight: 600,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const StyledTypographyEmail = styled(Typography)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'block',
});

export const StyledSuperAdminChip = styled(Chip)(({ theme }) => ({
  height: 16,
  fontSize: '0.625rem',
  backgroundColor: theme.palette.text.primary,
  color: theme.palette.background.paper,
  '& .MuiChip-label': {
    padding: '0 6px',
  },
}));

export const ProfileNameContainer = styled(Box)(({ theme }) => ({
  flex: 1, 
  minWidth: 0, 
  overflow: 'hidden'
}));

